module.exports = __webpack_public_path__ + "static/media/Покана и материали за свикване на ОСА на Формопласт АД, насрочено за 28 юни 2023 г..82556fc2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2023/Покана и материали за свикване на ОСА на Формопласт АД, насрочено за 28 юни 2023 г..pdf
// module id = 96
// module chunks = 0